export default class StickySection {
    constructor($element, breakpoint = 1200, marginTop = 0) {
        this.$element = $element;
        this.$header = this.$element.find('.js-sticky-header');
        this.$nav = $('.js-header');

        this.offset = 0;
        this.maxOffset = 0;
        this.enabled = false;

        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);

        this.breakpoint = breakpoint;
        this.marginTop = marginTop;

        this.onResize();
        this.onScroll();
        this.bindEvents();
    }

    bindEvents() {
        $(window).on('scroll', this.onScroll);
        $(window).on('resize', this.onResize);
    }

    onScroll() {
        if (!this.enabled) return;
        let scrollTop = $(window).scrollTop();

        this.offset = this.$element.offset().top;
        this.maxOffset = this.$header.parent().height() - this.$header.height();

        let numberPattern = /-?\d+\.?\d*/g;
        let transform = this.$nav.css('transform').match(numberPattern);

        if (transform === null) {
            transform = 0;
        } else {
            transform = parseInt(transform[5]);
        }

        let shown_nav_amount = this.$nav.height() + transform;

        let top = Math.max(scrollTop - this.offset + shown_nav_amount, 0);
        top = Math.min(top, this.maxOffset);

        if (top <= 0) {
            this.$header.css({'position': 'relative', 'bottom': 'auto', 'top': 0, 'transform': "translateY(0px)"});
        } else if (top > 0 && top < this.maxOffset) {
            this.$header.css({'position': 'fixed', 'top': this.marginTop, 'bottom': 'auto', 'transform': "translateY(" + shown_nav_amount + "px)"});
        } else {
            this.$header.css({'position': 'absolute', 'top': 'auto', 'bottom': 0, 'transform': "translateY(0px)",});
        }
    }

    onResize() {

        if ($(window).outerWidth() < this.breakpoint) {
            this.enabled = false;
            this.$header.css({'position': 'relative', 'bottom': 'auto', 'transform': "translateY(0px)"});
            return;
        }

        if(this.$header.outerHeight() >= this.$element.find('.js-static-content').outerHeight()){
            this.enabled = false;
            this.$header.css({'position': 'relative', 'bottom': 'auto', 'transform': "translateY(0px)"});
            return;
        }

        this.enabled = true;
        this.offset = this.$element.offset().top;
        this.maxOffset = this.$element.height() - this.$header.height();
    }
}
